import { isActionFromViewer } from "./isActionFromViewer";

export function ModifiedViewedByHost({ message, viewerRole }) {
  const didHostModify = isActionFromViewer(message, viewerRole);

  return didHostModify
    ? "Updated quote sent to organiser"
    : "The organiser has updated the event details";
}

export function ModifiedViewedByOrganiser({ message, viewerRole }) {
  const didOrganiserModify = isActionFromViewer(message, viewerRole);

  return didOrganiserModify
    ? "Updated event details sent to host"
    : "The host has updated their quote";
}
